import {useTranslation} from "react-i18next";

import {ComboboxGeneric} from "@/components/ui/combobox-generic";

import {tShiftTypeName} from "../../lib/shift-type-i18n";
import {shiftsService} from "../../services";
import {ShiftType} from "../../types";

type ShiftTypeItem = {
  label: string;
  value: ShiftType;
};

type ShiftTypeComboboxProps = {
  value: ShiftTypeItem | null;
  onChange: (value: ShiftTypeItem | null) => void;
  /** When set, restricts options (e.g. emergency shift by role). */
  items?: ShiftTypeItem[];
  disabled?: boolean;
};

export function ShiftTypeCombobox({value, onChange, items, disabled}: ShiftTypeComboboxProps) {
  const {t} = useTranslation("shifts");
  const {t: tCommon} = useTranslation("common");
  const list = items ?? shiftsService.shiftTypes;
  return (
    <ComboboxGeneric<ShiftTypeItem>
      items={list}
      value={value}
      onChange={onChange}
      disabled={disabled}
      getItemKey={(item) => item.value}
      getItemLabel={(item) => tShiftTypeName(item.value, t)}
      isItemEqual={(item, selected) => item.value === selected?.value}
      placeholder={tCommon("select_type")}
      emptyMessage="No items found."
    />
  );
}
